import React, { Component } from 'react';
import PropTypes from 'prop-types';
import EventEmitter, { EVENT_TYPES } from '@lib/eventEmitter';
import update from 'immutability-helper';
import { getValueFromString } from '@utils';
import FinanceRequest from '@lib/financeRequest';
import Finance from './finance';

export default class FinanceContainer extends Component {
  static displayName = 'FinanceContainer';
  static propTypes = {
    dealTotal: PropTypes.number,
    finance: PropTypes.object,
    isDepositSaved: PropTypes.bool,
    isEligibleForDealBuilder: PropTypes.bool,
    livePersonAvailable: PropTypes.bool,
    stockReference: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      finance: {
        selectedFinance: this.initialSelectedFinance(),
        ...this.props.finance,
        isDepositSaved: this.props.isDepositSaved,
      },
      loading: false,
      pcpError: '',
    };
  }

  componentDidMount() {
    EventEmitter.on(EVENT_TYPES.calculatedHpUpdate, this.updateHP);
    EventEmitter.on(EVENT_TYPES.calculatedPcpUpdate, this.updatePCP);
    EventEmitter.on(EVENT_TYPES.changedFinance, this.updateSelectedFinance);
    EventEmitter.on(EVENT_TYPES.failedPcpUpdate, this.updatePcpFailed);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.finance.pcp &&
      this.state.finance.pcp !== prevState.finance.pcp
    ) {
      this.setState({ loading: false });
    }
  }

  initialSelectedFinance() {
    if (this.props.finance.contract_hire) return 'contract_hire';
    if (this.props.finance.pcp && this.props.finance.cheapest_finance === 'pcp')
      return 'pcp';
    if (this.props.finance.hp) return 'hp';
  }

  updateSelectedFinance = (financeType) => {
    this.setState(
      update(this.state, {
        finance: {
          selectedFinance: { $set: financeType },
        },
      })
    );
  };

  updateHP = (illustration) => {
    this.setState(
      update(this.state, {
        finance: {
          hp: {
            illustration: { $set: illustration },
            calculator: {
              initialDeposit: { $set: illustration['Deposit'] },
              initialTerm: { $set: illustration['Term (months)'] },
            },
          },
        },
      })
    );
  };

  updatePCP = (illustration) => {
    const mileage = getValueFromString(illustration['Annual mileage']);
    this.setState(
      update(this.state, {
        finance: {
          pcp: {
            illustration: { $set: illustration },
            calculator: {
              initialDeposit: { $set: illustration['Deposit'] },
              initialTerm: { $set: illustration['Term (months)'] },
              initialAnnualMileage: { $set: mileage },
            },
          },
        },
      })
    );
  };

  setSelectedFinance = (event) => {
    const selectedFinance = event.target.value;
    EventEmitter.emit(
      EVENT_TYPES.changedFinance,
      selectedFinance,
      this.state.finance[selectedFinance].illustration['Deposit'],
      this.state.finance[selectedFinance].illustration['Monthly payment']
    );
  };

  hpCalculatorChanged = (...options) => {
    const [term, deposit, total, , isDepositSaved] = options;
    FinanceRequest().hpRequest({
      term,
      deposit,
      total,
      isDepositSaved,
      stockReference: this.props.stockReference,
    });
  };

  pcpCalculatorChanged = (term, deposit, total, mileage, isDepositSaved) => {
    this.setState({
      loading: true,
      pcpError: '',
    });

    FinanceRequest().pcpRequest({
      term,
      annual_mileage: mileage,
      deposit,
      isDepositSaved,
      total,
      stock_reference: this.props.stockReference,
    });
  };

  updatePcpFailed = (error) => {
    this.setState({
      loading: false,
      pcpError: error,
    });
  };

  submitFinanceEnquiry = (event) => {
    event.preventDefault();
    EventEmitter.emit(
      EVENT_TYPES.submittedFinance,
      this.state.finance[this.state.finance.selectedFinance].illustration
    );
  };

  render() {
    return this.state.finance.selectedFinance ? (
      <Finance
        {...this.state.finance}
        {...this.state}
        dealTotal={this.props.dealTotal}
        hpCalculatorChanged={this.hpCalculatorChanged}
        isEligibleForDealBuilder={this.props.isEligibleForDealBuilder}
        livePersonAvailable={this.props.livePersonAvailable}
        pcpCalculatorChanged={this.pcpCalculatorChanged}
        setSelectedFinance={this.setSelectedFinance}
        stockReference={this.props.stockReference}
        submitFinanceEnquiry={this.submitFinanceEnquiry}
      />
    ) : null;
  }
}
